import { render, staticRenderFns } from "./view7.vue?vue&type=template&id=0b5201c3&scoped=true"
import script from "./view7.vue?vue&type=script&lang=js"
export * from "./view7.vue?vue&type=script&lang=js"
import style0 from "./view7.vue?vue&type=style&index=0&id=0b5201c3&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b5201c3",
  null
  
)

export default component.exports